import { useState } from "react";
import { City } from "./city/City";
import { Country } from "./country/Country";
import { State } from "./state/State";

export const Places = () => {
    const [tab, setTab] = useState(1);
    return (
        <>
            {tab === 1 && <Country setTab={setTab} />}
            {tab === 2 && <State setTab={setTab} />}
            {tab === 3 && <City setTab={setTab} />}
        </>
    );
}